import { useSelector } from 'react-redux';
import Global from '../store/global-selectors';

export const useSellerHasBYOLOrderSource = () => {
  const marketplaces = useSelector(Global.selectReferenceDatagetMarketplaces);
  const sellerStores = useSelector(Global.selectSellerStores);

  const hasBYOLStore = sellerStores.reduce(
    (BYOLFound, { marketplaceId }) => BYOLFound || marketplaces.find((m) => m.marketplaceId === marketplaceId)?.bringYourOwnLabelCapable,
    false,
  );

  return hasBYOLStore;
};
